// Coming Soon strip — the merchandising numbers.
//
// A section with teased drills in it shows a short strip above the
// grid: the three most recently teased drills as greyed-out cards, and
// a count of everything coming.
//
// WHAT THE COUNT IS, PLAINLY: it is a floor plus the real teased rows,
// not a row count. With the baseline at 50 and three drills teased the
// strip reads 53. The floor stands for footage that exists and is not
// edited or uploaded yet, which is a real library rather than an
// invented one, but it is NOT queryable and nobody should ever wire a
// query to it or use it to reconcile against the drills table.
//
// Coleman sets the floor. Keep it to something he could stand behind if
// a coach asked how many were actually coming, and drop it as the
// backlog lands — a floor that never moves while the previews stay the
// same is how coaches learn the number is decoration.
export const COMING_SOON_BASELINE = 50;

// How many teased drills get a real card. The rest live inside the
// count. Three keeps the strip one row on a phone and makes it read as
// a rolling window rather than a display case.
export const COMING_SOON_PREVIEW = 3;

/**
 * What the strip should say, given the teased drills a section has.
 *
 * `preview`  the drills that get a card, newest first.
 * `total`    the number shown to coaches (floor + real teased rows).
 * `overflow` what the last card's "+N more" badge reads.
 */
export function comingSoonCounts(teasedItems) {
  const list = Array.isArray(teasedItems) ? teasedItems : [];
  const sorted = [...list].sort((a, b) => {
    const at = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bt = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return bt - at;
  });
  const preview = sorted.slice(0, COMING_SOON_PREVIEW);
  const total = COMING_SOON_BASELINE + list.length;
  return { preview, total, overflow: Math.max(0, total - preview.length) };
}
